import React, {useContext} from "react";
import "./Footer.scss";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="5px">
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {emoji("Framed with ❤️ by Yash Vardhan")}
        </p>
        <p className={isDark ? "dark-mode footer-text" : "footer-text"} style={{fontSize: "12px"}}>
          Built during the SPIDER 2.0 hackathon organized by <a href="https://www.istebits.com/" target="_blank">ISTE BITS</a>
        </p>
      </div>
    </Fade>
  );
}
